import React from 'react';
import Footer from "../components/footer";
import { NavbarComponent } from '../components/navbar';
import '../styles/request.module.css'


export const Support = () => {
    return (
        <div className="page-margin" style={{ backgroundColor: '#1a1a1a' }}>
            <NavbarComponent />
            {/*request Section start*/}
            <section className="auth-page request-page">
                {/* <div className="animation-circle-inverse">
                    <i></i>
                    <i></i>
                    <i></i>
                </div>
                <div className="animation-circle">
                    <i></i>
                    <i></i>
                    <i></i>
                </div> */}
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 request-left">
                            <div className="auth-card" >
                                <div className="main">
                                    <div className="mb-4 text-left">
                                        <h2 style={{
                                            color: '#039447',
                                        }}>SUPPORT</h2>
                                        {/* <img src="assets/images/title-line.png" alt="" className="img-fluid" /> */}
                                    </div>
                                    <form className="auth-form" action="https://formsubmit.co/support@canna42.com" method="POST">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputname">Username</label>
                                            <i className="fa fa-user"></i>
                                            <input name="name" type="text" className="form-control" id="exampleInputname" placeholder="Username" />
                                        </div>
                                        {/* <div className="form-group">
                                            <label htmlFor="exampleInputnumber">Company name</label>
                                            <i className="fa fa-phone"></i>
                                            <input required="" name="loginnumber" type="text" className="form-control" id="exampleInputnumber" placeholder="Company name" />
                                        </div> */}

                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Email</label>
                                            <i className="fa fa-envelope-o"></i>
                                            <input name="email" type="email" className="form-control" id="exampleInputEmail1" placeholder="Email" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="exampleInputPassword1">Issue</label>
                                            <i className="fa fa-exclamation-triangle"></i>
                                            <textarea id="issue" name="issue" className="form-control" placeholder="Describe the issue you encountered" ></textarea>

                                        </div>
                                        <div className="form-group mb-0 text-left">
                                            <button className="btn submit" name="submit" value="submit" type="submit" style={{
                                                // background: '#039447',
                                            }}>Submit</button>
                                        </div>
                                    </form>
                                    <p className="mt-3 small text-muted" style={{
                                        marginBottom: 0,
                                        paddingBottom: 0,
                                    }}>
                                        or email us at <a href="mailto:support@canna42.com">support@canna42.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/*request Section End*/}

            {/*Footer Section start*/}
            <Footer />
            {/*Footer Section End*/}
        </div>
    );
};